import { Guid } from "@/types"

import ShippingOrderCartSegment, { IGetShippingOrderCartSegmentDto } from "./ShippingOrderCartSegment"
import ShippingOrderTransportBase, { IGetShippingOrderTransportBaseDto, IInitShippingOrderTransportBase } from "./ShippingOrderTransportBase"

export interface IGetShippingOrderCartTransportDto extends IGetShippingOrderTransportBaseDto {
    segments: IGetShippingOrderCartSegmentDto[]
}

interface IInitShippingOrderCartTransport extends IInitShippingOrderTransportBase {
    dto: IGetShippingOrderCartTransportDto
}

export interface ICreateShippingOrderCartTransportDto {
    description?: string | null
    carrier?: string | null
    measurementSystemId: Guid
    dimension1?: number | null
    dimension2?: number | null
    dimension3?: number | null
    payload?: number | null
}

export interface IUpdateShippingOrderCartTransportDto {
    id: Guid
    description?: string | null
    carrier?: string | null
    measurementSystemId?: Guid
    dimension1?: number | null
    dimension2?: number | null
    dimension3?: number | null
    payload?: number | null
    sequence?: number
}

export default class ShippingOrderCartTransport extends ShippingOrderTransportBase {
    segments: ShippingOrderCartSegment[]

    constructor(params: IInitShippingOrderCartTransport) {
        super(params)
        this.segments = params.dto.segments.map((sDto, idx) => new ShippingOrderCartSegment(sDto, idx))
    }

    toCreateDto(): ICreateShippingOrderCartTransportDto {
        return {
            description: this.description,
            carrier: this.carrier,
            measurementSystemId: this.sizeUnit?.id || "",
            dimension1: this.dimension1,
            dimension2: this.dimension2,
            dimension3: this.dimension3,
            payload: this.payload,
        }
    }
}
